import { AuthFlowError } from '@griply/types';
import { useMutation } from '@tanstack/react-query';
import { verifyEmail } from 'shared/services/backend-api';

export const useVerifyEmailMutation = () =>
  useMutation<void, AuthFlowError, string | undefined>({
    mutationFn: async (code) => {
      await verifyEmail(code ?? '');
    },
  });
